import { motion } from "framer-motion";
import React from "react";
import { UserRole } from "../../../types/user";

interface RoleSelectionProps {
  onRoleSelect: (role: UserRole) => void;
  roleCategories: Record<string, UserRole[]>;
  requiresInstitution: (role: UserRole) => boolean;
  getRoleDisplayName: (role: UserRole) => string;
}

const RoleSelection: React.FC<RoleSelectionProps> = ({
  onRoleSelect,
  roleCategories,
  requiresInstitution,
  getRoleDisplayName,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="space-y-6"
    >
      <div className="text-center">
        <h3 className="text-lg font-medium text-gray-900">Select User Role</h3>
        <p className="text-sm text-gray-500 mt-1">
          Choose the appropriate role for this user
        </p>
      </div>

      {Object.entries(roleCategories).map(([category, roles]) => (
        <div key={category} className="space-y-3">
          <h4 className="text-sm font-medium text-gray-700 capitalize">
            {category} Roles
          </h4>
          <div className="grid grid-cols-1 gap-2">
            {roles.map((role) => (
              <button
                key={role}
                onClick={() => onRoleSelect(role)}
                className="text-left p-3 border border-gray-200 rounded-lg hover:border-primary-500 hover:bg-primary-50 transition-colors"
              >
                <div className="font-medium text-gray-900">
                  {getRoleDisplayName(role)}
                </div>
                {requiresInstitution(role) && (
                  <div className="text-xs text-blue-600 mt-1">
                    Requires institution assignment
                  </div>
                )}
              </button>
            ))}
          </div>
        </div>
      ))}
    </motion.div>
  );
};

export default RoleSelection;
